export const isMetafieldValueTrue = (value) => typeof value === 'string' && value.trim().toLowerCase() === 'true';

// List metafields hold a JSON array such as '["Net30"]', so an empty list counts as no value
export const isMetafieldValuePresent = (value) => {
	if (typeof value !== 'string' || !value.trim()) return false;

	try {
		const parsed = JSON.parse(value);
		if (Array.isArray(parsed)) {
			return parsed.some(item => String(item ?? '').trim() !== '');
		}
	} catch {
		// Plain text rather than JSON
	}

	return true;
};
